/**
 * @generated SignedSource<<27d7678abca0e15859c3e19d98f44912>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ParticipativeModuleResultsFormFieldBar_result",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ParticipativeModuleResultsFormFieldContainer_result"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ParticipativeModuleResultsFormFieldChoicesChart_result"
    }
  ],
  "type": "ParticipativeModuleResultsFormFieldBar",
  "abstractKey": null
};

node.hash = "68c404905f846091f542f99e1ca437db";

module.exports = node;
